import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { IsAuthorizedUserGuard } from '@tablesready/common-ui';
import { AuthenticatedLayoutComponent, DefaultPageGuard } from './components';
import { AppCanActivateGuard } from '@tablesready/frontend-auth';
import { starterPlanGuard, businessPlanGuard } from './guards';

const appRoutes: Routes = [
  {
    path: '',
    component: AuthenticatedLayoutComponent,
    canActivate: [AppCanActivateGuard],
    canActivateChild: [AppCanActivateGuard],
    children: [
      {
        path: 'analytics',
        canActivate: [starterPlanGuard],
        loadChildren: () => import(/* webpackChunkName: "manager-analytics" */ './analytics/analytics.module')
          .then((module) => module.AnalyticsModule),
      },
      {
        path: 'customers',
        loadChildren: () => import(/* webpackChunkName: "manager-customers" */ './customers/customers.module')
          .then(module => module.CustomersModule),
      },
      {
        path: 'history',
        loadChildren: () => import(/* webpackChunkName: "manager-history" */ './history/history.module')
          .then((module) => module.HistoryModule),
      },
      {
        path: 'togo',
        canActivate: [businessPlanGuard],
        loadChildren: () => import(/* webpackChunkName: "manager-togo" */ './togo/togo.module')
          .then(module => module.TogoModule),
      },
      {
        path: 'waitlist',
        loadChildren: () => import(/* webpackChunkName: "manager-waitlist" */ './waitlist/waitlist.module')
          .then(module => module.WaitlistModule),
      },
      {
        path: 'floorplan',
        loadChildren: () => import(/* webpackChunkName: "manager-floorplan" */ './floorplan/floorplan.module')
          .then(module => module.FloorplanModule),
      },
      {
        path: 'import',
        loadChildren: () => import(/* webpackChunkName: "manager-import" */ './import/import.module')
          .then(module => module.ImportModule),
      },
      {
        path: 'root',
        loadChildren: () => import(/* webpackChunkName: "manager-root" */ './root/root-module')
          .then(module => module.RootModule),
      },
      {
        path: 'settings',
        loadChildren: () => import(/* webpackChunkName: "manager-settings" */ './settings/settings.module')
          .then(module => module.SettingsModule),
      },
      {
        path: 'reservations',
        loadChildren: () => import(/* webpackChunkName: "manager-reservations" */ './reservations/reservations.module')
          .then(module => module.ReservationsModule),
      },
      {
        path: '',
        children: [],
        canActivate: [DefaultPageGuard],
      },
    ],
  },
  {
    path: '',
    children: [
      {
        path: 'login',
        canActivate: [IsAuthorizedUserGuard],
        loadChildren: () => import(/* webpackChunkName: "manager-login" */ './auth/auth.module').then(module => module.AuthModule),
      },
      {
        path: 'verify',
        loadChildren: () => import(/* webpackChunkName: "manager-verify" */ './verification/verification.module')
          .then(module => module.VerificationModule),
      },
      {
        path: 'restore-password',
        loadChildren: () => import(/* webpackChunkName: "manager-restore-password" */ './restore-password/restore-password.module')
          .then(module => module.RestorePasswordModule),
      },
      {
        path: 'invite',
        loadChildren: () => import(/* webpackChunkName: "manager-auth-invite" */ './signup-by-invite/signup-by-invite.module')
          .then(module => module.SignupByInviteModule),
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
